import { render, staticRenderFns } from "./BodyDeAditivos.vue?vue&type=template&id=7d6befb2&scoped=true"
import script from "./BodyDeAditivos.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeAditivos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeAditivos.vue?vue&type=style&index=0&id=7d6befb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6befb2",
  null
  
)

export default component.exports